import React from 'react';

import FreeText from './../overlays/FreeText';
import Crawl from './../overlays/Crawl';
import LineUp from './../overlays/LineUp';
import Overlay from './../overlays/Overlay'
import Bowl from './../overlays/Bowl'

class VolleyballMapping extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <>
      <Overlay stateName="Volleyball_button_countdown" display={this.props.display}  theme={this.props.theme} overlayConf="Volleyball_countdown"/>
      <Overlay stateName="Volleyball_button_referee_info" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_referee_info"/>
      <Overlay stateName="Volleyball_button_crew_info" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_crew_info"/>
      <Overlay stateName="Volleyball_button_coach_info" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_coach_info"/>
      <Overlay stateName="Volleyball_button_substitution" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_substitution"/>
      <Overlay stateName="Volleyball_button_playerinfo" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_player_info"/>
      <Overlay stateName="Volleyball_button_point_home" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_point"/>
      <Overlay stateName="Volleyball_button_point_guest" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_point"/>
      <Overlay stateName="any_button_advertisement" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_advertisement"/>
      <LineUp stateName="Volleyball_button_lineup" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_lineup"/>
      <Overlay stateName="Volleyball_button_home_team_info" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_team_info"/>
      <Overlay stateName="Volleyball_button_guest_team_info" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_team_info"/>

      <Overlay stateName="Volleyball_vs_and_score_serve_home" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_vs_and_score_serve_home"/>
      <Overlay stateName="Volleyball_vs_and_score_serve_guest" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_vs_and_score_serve_guest"/>

      <Overlay stateName="Volleyball_button_vs_and_score_mini" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_vs_and_score_mini"/>
      <Overlay stateName="Volleyball_button_vs_and_score_full" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_vs_and_score_full"/>

      <Overlay stateName="Volleyball_button_clock" display={this.props.display} theme={this.props.theme} overlayConf="Volleyball_analog_clock"/>

      <FreeText stateName="Volleyball_button_freetext" display={this.props.display}  theme={this.props.theme} overlayConf="Volleyball_freetext"/>
      <Crawl stateName="Volleyball_button_freetext_crawl" display={this.props.display}  theme={this.props.theme} overlayConf="Volleyball_freetext_crawl"/>
    </>

    );
  }

}
export default VolleyballMapping;
